import { memo } from 'react';
import Box from '@mui/material/Box';
import { UserFormData } from 'types/user';
import { validationSchema } from './validation';
import { Form } from 'components/@shared/Form/Form';
import Stack from '@mui/material/Stack';
import { initialValues } from './constants';
import { FormTextField } from 'components/@shared/Form/TextField';
import { FormPatternTextField } from 'components/@shared/Form/FormPatternTextField';
import { GoBackButton } from 'components/@shared/GoBackButton';
import Button from '@mui/material/Button';
import { AvatarUploader } from 'components/@shared/Form/AvatarUploader';
import { FormGoogleAutocomplete } from 'components/@shared/Form/FormGoogleAutocomplete';

interface Props {
    initialData?: UserFormData;
    onSubmit: (values: UserFormData) => void;
}

export const UserProfileForm = memo(({ initialData = initialValues, onSubmit }: Props) => {
    return (
        <Form initialValues={initialData} validationSchema={validationSchema} onSubmit={onSubmit}>
            <Stack gap={2} pt={3} pb={3} maxWidth={1000} mx="auto">
                <Box mx="auto">
                    <AvatarUploader image={initialData.profilePicture} name="profilePicture" />
                </Box>
                <FormTextField name="firstName" label="First Name" fullWidth size="small" />
                <FormTextField name="lastName" label="Last Name" fullWidth size="small" />
                <FormPatternTextField
                    format="###-###-####"
                    mask="_"
                    name="phoneNumber"
                    label="Phone"
                    fullWidth
                    size="small"
                />
                <FormGoogleAutocomplete name="address" />
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
                    <GoBackButton />
                    <Button variant="contained" type="submit">
                        Save
                    </Button>
                </Box>
            </Stack>
        </Form>
    );
});

UserProfileForm.displayName = 'UserProfileForm';
